import { render, staticRenderFns } from "./ClaimsLookupInitial.vue?vue&type=template&id=7d6f9da0"
import script from "./ClaimsLookupInitial.vue?vue&type=script&lang=ts"
export * from "./ClaimsLookupInitial.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports